<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="orderRecordSearchForm" :model="orderRecordSearchForm" size="mini" inline label-width="100px" label-position="right">
							<el-form-item label="支付单号" property="outTradeNo">
								<span>
									<el-input v-model="orderRecordSearchForm.outTradeNo" placeholder="请输入订单号(16开头)" clearable @keyup.enter.native="searchOrderRecordList"></el-input>
								</span>
							</el-form-item>
							<el-form-item label="订单号" property="orderNo">
								<span>
									<el-input v-model="orderRecordSearchForm.orderNo" placeholder="请输入订单号(年份开头)" clearable @keyup.enter.native="searchOrderRecordList"></el-input>
								</span>
							</el-form-item>
							<el-form-item label="日期">
								<el-date-picker
									v-model="orderRecordDate"
									type="date"
									placeholder="选择日期"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									style="width: 200px;"
									@change="searchOrderRecordList"
								>
								</el-date-picker>
							</el-form-item>
							<div class="search-box-button search-button search_box_button_right">
								<el-button size="mini" type="primary" @click.native.prevent="searchOrderRecordList">搜 索</el-button>
								<el-button size="mini" @click="resetOrderRecordSearchForm">重 置</el-button>
							</div>
						</el-form>
					</div>
					<hr class="search_border">
					<div class="search_tools_div">
						<div class="search_tools_text">订单列表</div>
					</div>
					<el-table
						v-loading='orderRecordLoading'
						:data="orderRecordTableData"
						tooltip-effect="dark"
						border
						stripe
						style="margin-top: 20px;"
					>
						<el-table-column type="index" width="60" align="center" label="编号"></el-table-column>
						<el-table-column prop="orderNo" label="订单号" align="center" width="210" ></el-table-column>
						<el-table-column prop="outTradeNo" label="支付单号" align="center" ></el-table-column>
						<el-table-column prop="chargingMinutes" label="下单时长(分钟)" align="center" width="120"></el-table-column>
						<el-table-column prop="chargeEndTime" label="充电状态" align="center" width="100">
							<template slot-scope="scope">
								<span v-if="!scope.row.paymentStatus">
									-
								</span>
								<span v-else>
									<el-tag v-if="scope.row.chargeEndTime" type="info">已结束</el-tag>
									<el-tag v-else type="warning">进行中</el-tag>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="amount" label="支付费用(元)" align="center" width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.amount">¥{{ formatAmount(scope.row.amount) }}</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="deductMinutes" label="扣除结余时间" align="center" width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.deductMinutes">{{ scope.row.deductMinutes }}</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="paymentStatus" label="支付状态" align="center" width="100">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.paymentStatus == 1" type="success">已支付</el-tag>
								<el-tag v-else type="danger">未支付</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="createTime" label="下单时间" align="center"></el-table-column>

						<el-table-column prop="chargingOrderNo" label="操作" align="center" width="100" fixed="right">
							<template slot-scope="scope">
								<el-button type="text" v-if="scope.row.chargingOrderNo" @click="viewOrderRecordDetail(scope.row)">查看详情</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页 -->
					<el-pagination
						@size-change="handleOrderRecordSizeChange"
						@current-change="handleOrderRecordCurrentChange"
						layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[10, 20, 50, 100]"
						:current-page="orderRecordCurrent"
						:page-size="orderRecordSize"
						:total="orderRecordTotal"
						style="margin-top: 20px; float: right;"
					>
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!-- 订单详情弹窗 -->
		<el-dialog
			title="订单详情"
			:visible.sync="orderDetailDialogVisible"
			width="800px"
			top="10vh"
			:before-close="closeOrderDetailDialog"
		>
			<div v-if="orderDetail" class="order-detail-container">
				<!-- 订单基本信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-document"></i>
						<span>订单信息</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">支付订单号：</span>
								<span class="detail-value">{{ clickRow.outTradeNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">openId：</span>
								<span class="detail-value">{{ clickRow.openid || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">订单号：</span>
								<span class="detail-value">{{ clickRow.orderNo || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">设备位置：</span>
								<span class="detail-value">{{ orderDetail.device_tags || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">端口号：</span>
								<span class="detail-value">{{ orderDetail.port || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付费用：</span>
								<span class="detail-value highlight" v-if="clickRow.amount">¥{{ formatAmount(clickRow.amount || 0) }}</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes && clickRow.amount">+</span>
								<span class="detail-value highlight" v-if="clickRow.deductMinutes">{{ clickRow.deductMinutes ? clickRow.deductMinutes + '结余时间' : '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">支付状态：</span>
								<el-tag v-if="clickRow.paymentStatus == 1" type="success">已支付</el-tag>
								<el-tag v-else type="danger">未支付</el-tag>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时长：</span>
								<span class="detail-value">{{ clickRow.chargingMinutes || '0' }}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">下单时间：</span>
								<span class="detail-value">{{ clickRow.createTime || '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- 充电时间信息 -->
				<div class="detail-section">
					<div class="section-title">
						<i class="el-icon-time"></i>
						<span>充电记录</span>
					</div>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实时功率：</span>
								<span class="detail-value">{{ orderDetail.power || '0' }}W
									<el-button title="实时功率曲线图" type="text" icon="el-icon-data-line" @click="togglePowerChart" style="margin-left: 20px;"></el-button>
								</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">消耗电量：</span>
								<span class="detail-value">{{ orderDetail.elec || '0' }}度</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">充电状态：</span>
								<el-tag v-if="orderDetail.is_running == 1" type="primary">充电中</el-tag>
								<el-tag v-else type="info">充电结束</el-tag>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">实际充电时长：</span>
								<span class="detail-value">{{ orderDetail.is_running == 1 ? orderDetail.minute || '-' : orderDetail.minute}}</span>
								<span class="detail-label">分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">开始充电时间：</span>
								<span class="detail-value">{{ orderDetail.start_date || '-' }}</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">结束充电时间：</span>
								<span class="detail-value">{{ orderDetail.end_date || '-' }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="orderDetail.is_running == 1" class="detail-row">
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">已充电时长：</span>
								<span class="detail-value">{{ getChargedDuration() }}分钟</span>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="detail-item">
								<span class="detail-label">剩余时长：</span>
								<span class="detail-value">{{ getRemainingDuration() }}分钟</span>
							</div>
						</el-col>
					</el-row>
					<el-row v-if="orderDetail.is_running != 1" :gutter="20" class="detail-row">
						<el-col :span="24">
							<div class="detail-item">
								<span class="detail-label">结束原因：</span>
								<span class="detail-value highlight">{{ orderDetail.reason >= 0 ? reasonArr.find(item => item.value == orderDetail.reason).label : '-' }}</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<!-- ECharts container -->
				<div v-if="showPowerChart" ref="powerChart" style="width: 100%; height: 300px; margin-top: 20px;"></div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeOrderDetailDialog">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { updatePoints, getPointsDetailList } from '@/apis/customer'
import { getRecordes, getOrderInfo } from '@/apis/devices'
import * as echarts from 'echarts';
import dayjs from 'dayjs'
export default {
	name: "Customer",	// 客户管理
	data() {
		return {
			loading: true,

			searchForm: {},

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			title: '新增',
			editForm: {},

			tableData: [],

			jfDialogVisible: false,
			jfTitle: '结余时间操作',
			jfForm: {
				type: '发放'
			},
			jfFormRules: {
				type: [
					{required: true, message: '请选择类型', trigger: 'blur'}
				],
				points: [
					{required: true, message: '请输入结余时间', trigger: 'blur'}
				],
				remark: [
					{required: false, message: '请输入备注', trigger: 'blur'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',

			// 结余时间明细相关
			detailDialogVisible: false,
			detailTitle: '结余时间明细',
			detailLoading: false,
			detailTableData: [],
			detailSearchForm: {},
			detailDateRange: [],
			detailCurrent: 1,
			detailSize: 10,
			detailTotal: 0,
			currentOpenid: '', // 当前查看明细的用户openid

			// 订单详情弹窗相关
			orderDetailDialogVisible: false,
			orderDetail: null, // 订单详情数据
			clickRow: null, // 点击的行数据
			showPowerChart: false, // 是否显示功率图表
			powerChartInstance: null, // 图表实例

			// 订单记录弹窗相关
			orderRecordDialogVisible: false,
			orderRecordTitle: '订单记录',
			orderRecordLoading: false,
			orderRecordTableData: [],
			orderRecordSearchForm: {},
			orderRecordDate: null,
			orderRecordCurrent: 1,
			orderRecordSize: 10,
			orderRecordTotal: 0,
			currentOrderRecordOpenid: '', // 当前查看订单记录的用户openid

			reasonArr: [
				{value: 0 , label: '充电时间/电量用完了'},
				{value: 1 , label: '充满了或充电功率低'},
				{value: 2 , label: '充电满了，自动停止'},
				{value: 3 , label: '充电结束'},
				{value: 4 , label: 'D功率过大，充电结束'},
				{value: 5 , label: '刷卡退费结束'},
				{value: 6 , label: '充电功率低停止充电'},
				{value: 7 , label: '系统关机'},
				{value: 8 , label: '烟雾报警停止'},
				{value: 9 , label: '过压'},
				{value: 10, label:  '欠压'},
				{value: 11, label:  '高温'},
				{value: 12, label:  'Z功率过大，充电结束'},
				{value: 13, label:  '因固件升级，充电结束'},
				{value: 14, label:  '强磁'},
				{value: 15, label:  '功率过大/短路'},
				{value: 71, label:  '管理后台结束充电'},
				{value: 72, label:  '商户后台结束充电'},
				{value: 73, label:  '用户手动结束充电'},
				{value: 88, label:  '充电费用用完了'},
				{value: 98, label:  '开机失败'},
				{value: 99, label:  '充电结束。'},
			]
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	mounted() {
		this.getOrderRecordList()
	},
	methods: {
		getPointsDetailList() {
			this.detailLoading = true
			let params = {
				page: this.detailCurrent,
				pageSize: this.detailSize,
				openid: this.currentOpenid
			}
			// 添加日期范围
			if (this.detailDateRange && this.detailDateRange.length === 2) {
				params.startTime = this.detailDateRange[0]
				params.endTime = this.detailDateRange[1]
			}
			// 如果有类型筛选，也可以添加
			if (this.detailSearchForm.type) {
				params.type = this.detailSearchForm.type
			}
			getPointsDetailList(params).then(res => res.data).then(res => {
				// console.log('结余时间明细列表:', res)
				if (res.code == 200) {
					this.detailTableData = res.data.list || res.data.records || []
					this.detailTotal = res.data.total || res.data.totalElements || 0
				} else {
					this.$message({
						showClose: true,
						message: res.msg || '获取结余时间明细失败',
						type: 'error'
					})
					this.detailTableData = []
					this.detailTotal = 0
				}
				this.detailLoading = false
			}).catch(err => {
				console.error('获取结余时间明细失败:', err)
				this.$message({
					showClose: true,
					message: '获取结余时间明细失败',
					type: 'error'
				})
				this.detailLoading = false
				this.detailTableData = []
				this.detailTotal = 0
			})
		},
		searchDetailList() {
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		resetDetailSearchForm() {
			this.detailSearchForm = {}
			this.detailDateRange = []
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		handleDetailSizeChange(val) {
			this.detailSize = val
			this.detailCurrent = 1
			this.getPointsDetailList()
		},
		handleDetailCurrentChange(val) {
			this.detailCurrent = val
			this.getPointsDetailList()
		},
		// 订单记录相关方法
		orderRecordHandle(row) {
			this.orderRecordTitle = '订单记录 - ' + row.nickname
			this.currentOrderRecordOpenid = row.openid
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordCurrent = 1
			this.orderRecordSize = 10
			this.orderRecordDialogVisible = true
			this.getOrderRecordList()
		},
		handleOrderRecordClose() {
			this.orderRecordDialogVisible = false
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordTableData = []
			this.currentOrderRecordOpenid = ''
		},
		getOrderRecordList() {
			this.orderRecordLoading = true
			let params = {
				pageNum: this.orderRecordCurrent,
				pageSize: this.orderRecordSize,
				openid: this.currentOrderRecordOpenid,
				...this.orderRecordSearchForm
			}
			// 添加日期筛选
			if (this.orderRecordDate) {
				params.date = this.orderRecordDate
			}
			getRecordes(params).then(res => res.data).then(res => {
				if (res.code == 200) {
					this.orderRecordTableData = res.data.list || res.data.records || []
					this.orderRecordTotal = res.data.total || res.data.totalElements || 0
				} else {
					this.$message({
						showClose: true,
						message: res.msg || res.message || '获取订单记录失败',
						type: 'error'
					})
					this.orderRecordTableData = []
					this.orderRecordTotal = 0
				}
				this.orderRecordLoading = false
			}).catch(err => {
				console.error('获取订单记录失败:', err)
				this.$message({
					showClose: true,
					message: '获取订单记录失败',
					type: 'error'
				})
				this.orderRecordLoading = false
				this.orderRecordTableData = []
				this.orderRecordTotal = 0
			})
		},
		searchOrderRecordList() {
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		resetOrderRecordSearchForm() {
			this.orderRecordSearchForm = {}
			this.orderRecordDate = null
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		handleOrderRecordSizeChange(val) {
			this.orderRecordSize = val
			this.orderRecordCurrent = 1
			this.getOrderRecordList()
		},
		handleOrderRecordCurrentChange(val) {
			this.orderRecordCurrent = val
			this.getOrderRecordList()
		},
		// 查看订单记录详情
		viewOrderRecordDetail(row) {
			if (!row.chargingOrderNo) {
				this.$message({
					type: 'warning',
					message: '充电订单号不存在，无法查看详情'
				})
				return
			}
			this.getOrderDetail(row)
		},
		// 查看订单详情
		viewDetailHandle(row) {
			if (!row.orderNo) {
				this.$message({
					type: 'warning',
					message: '订单号不存在，无法查看详情'
				})
				return
			}

			const loading = this.$loading({
				text: '加载中...',
				lock: true
			})

			// 调用 getRecordes 接口，传递 orderNo
			getRecordes({
				pageNum: 1,
				pageSize: 10,
				orderNo: row.orderNo
			}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200 && res.data && res.data.list && res.data.list.length > 0) {
					// 从返回的数组数据中获取 chargingOrderNo
					const orderItem = res.data.list[0]
					if (orderItem.chargingOrderNo) {
						// 调用 getOrderInfo 获取订单详情
						this.getOrderDetail(orderItem)
					} else {
						this.$message({
							type: 'warning',
							message: '未找到充电订单号'
						})
					}
				} else {
					this.$message({
						type: 'warning',
						message: res.message || '未找到相关订单'
					})
				}
			}).catch(error => {
				loading.close()
				console.error('获取订单列表失败:', error)
				this.$message({
					type: 'error',
					message: '获取订单列表失败，请稍后再试'
				})
			})
		},
		// 获取订单详情
		getOrderDetail(row) {
			this.clickRow = row
			this.showPowerChart = false
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose()
				this.powerChartInstance = null
			}

			if (!row.chargingOrderNo) {
				this.$message({
					type: 'warning',
					message: '充电订单号不存在，无法查看详情'
				})
				return
			}

			const loading = this.$loading({
				text: '加载订单详情...',
				lock: true
			})

			getOrderInfo({
				orderNo: row.chargingOrderNo
			}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200 && res.data) {
					this.orderDetail = res.data.data
					this.orderDetailDialogVisible = true
				} else {
					this.$message({
						type: 'error',
						message: res.message || '获取订单详情失败'
					})
				}
			}).catch(error => {
				loading.close()
				console.error('获取订单详情失败:', error)
				this.$message({
					type: 'error',
					message: '获取订单详情失败，请稍后再试'
				})
			})
		},
		// 关闭订单详情弹窗
		closeOrderDetailDialog() {
			this.orderDetailDialogVisible = false
			this.orderDetail = null
			this.clickRow = null
			this.showPowerChart = false
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose()
				this.powerChartInstance = null
			}
		},
		// 格式化金额（分转元）
		formatAmount(amount) {
			if (!amount && amount !== 0) return '0.00'
			amount = amount / 100
			return parseFloat(amount).toFixed(2)
		},
		// 计算已充电时长 (分钟)
		getChargedDuration() {
			if (!this.orderDetail || !this.orderDetail.start_date) return 0
			const start = dayjs(this.orderDetail.start_date)
			const now = dayjs()
			const diff = now.diff(start, 'minute')
			return diff > 0 ? diff : 0
		},
		// 计算剩余时长 (分钟)
		getRemainingDuration() {
			const charged = this.getChargedDuration()
			const total = Number(this.clickRow.chargingMinutes) || 0
			const remaining = total - charged
			return remaining > 0 ? remaining : 0
		},

		togglePowerChart() {
			this.showPowerChart = !this.showPowerChart;
			if (this.showPowerChart) {
				this.$nextTick(() => {
					this.initPowerChart();
				});
			} else {
				if (this.powerChartInstance) {
					this.powerChartInstance.dispose();
					this.powerChartInstance = null;
				}
			}
		},

		initPowerChart() {
			if (!this.orderDetail || !this.orderDetail.powers || this.orderDetail.powers.length === 0) {
				this.$message.info('暂无功率数据');
				this.showPowerChart = false;
				return;
			}
			const Arr = JSON.parse(JSON.stringify(this.orderDetail.powers));
			// Arr.reverse()
			Arr.sort((a, b) => parseInt(a.create_time) - parseInt(b.create_time));

			const chartDom = this.$refs.powerChart;
			if (this.powerChartInstance) {
				this.powerChartInstance.dispose();
			}
			this.powerChartInstance = echarts.init(chartDom);

			const option = {
				title: {
					text: '实时功率曲线',
					left: 'center'
				},
				tooltip: {
					trigger: 'axis'
				},
				xAxis: {
					type: 'category',
					data: Arr.map(item => item.create_time_str),
					axisLabel: {
						rotate: 45, // Rotate labels to prevent overlap
						interval: 'auto'
					}
				},
				yAxis: {
					type: 'value',
					name: '功率 (W)',
					axisLabel: {
						formatter: '{value} W'
					}
				},
				series: [
					{
						name: '功率',
						type: 'line',
						data: Arr.map(item => item.instand_power),
						smooth: true
					}
				],
				grid: {
					left: '10%',
					right: '10%',
					bottom: '15%'
				},
				dataZoom: [ // Add data zoom for better navigation on long time series
					{
						type: 'inside',
						start: 0,
						end: 100
					},
					{
						start: 0,
						end: 100
					}
				],
			};
			this.powerChartInstance.setOption(option);
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

/* 订单详情弹窗样式 */
.order-detail-container {
	padding: 10px 0;
}

.detail-section {
	margin-bottom: 30px;
	padding: 20px;
	background: #f8f9fa;
	border-radius: 8px;
	border-left: 4px solid #409EFF;
}

.section-title {
	display: flex;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 20px;
	padding-bottom: 10px;
	border-bottom: 2px solid #e4e7ed;
}

.section-title i {
	font-size: 18px;
	margin-right: 8px;
	color: #409EFF;
}

.detail-row {
	margin-bottom: 15px;
}

.detail-row:last-child {
	margin-bottom: 0;
}

.detail-item {
	display: flex;
	align-items: center;
	min-height: 32px;
}

.detail-label {
	font-size: 14px;
	color: #606266;
	font-weight: 500;
	min-width: 120px;
	flex-shrink: 0;
}

.detail-value {
	font-size: 14px;
	color: #303133;
	flex: 1;
	word-break: break-all;
}

.detail-value.highlight {
	color: #409EFF;
	font-weight: 600;
	font-size: 15px;
}
</style>